import { UrlConstants } from "../url.constants";
export class ApiMobileConfigConstants {
    static URL = UrlConstants.API_V2 + "MobileConfig";
}
